import { render } from "./MobileMainNav.vue?vue&type=template&id=1c542bec&scoped=true"
import script from "./MobileMainNav.vue?vue&type=script&lang=js"
export * from "./MobileMainNav.vue?vue&type=script&lang=js"

import "./MobileMainNav.vue?vue&type=style&index=0&id=1c542bec&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c542bec"]])

export default __exports__